<template>
  <v-container class="pt-1 pb-12 py-sm-12 px-4 px-sm-0">

    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
    </v-overlay>

    <!-- HEADER DESKTOP -->
   <v-row class="mb-4 d-none d-sm-flex">
  <v-col cols="12" class="px-4 py-0">
   <div class="title-container d-flex justify-space-between align-center">

     <div>
  <div class="d-flex align-center ga-3">
    <span class="page-title">{{ page.title }}</span>
    <v-menu offset-y transition="slide-y-transition">
  <template v-slot:activator="{ on, attrs }">
    <v-btn small color="primary" text v-bind="attrs" v-on="on">
      <v-icon left>mdi-help-circle-outline</v-icon>Ajuda
    </v-btn>
  </template>
              <v-card min-width="380px">
                <v-card-title class="text-h6 font-weight-bold pb-2">
                  <v-icon small class="mr-2">mdi-lightbulb-on</v-icon>Ajuda dos Campos
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-3 pb-3">
                  <div class="mb-3"><p class="font-weight-bold text-caption mb-1">📝 Nome do Combo</p><p class="text-caption grey--text">Identificador único do combo (ex: Combo Premium)</p></div>
                  <v-divider class="my-2"></v-divider>
                  <div class="mb-3"><p class="font-weight-bold text-caption mb-1">💵 Valor Pago</p><p class="text-caption grey--text">Valor que o cliente paga para obter o crédito</p></div>
                  <v-divider class="my-2"></v-divider>
                  <div class="mb-3"><p class="font-weight-bold text-caption mb-1">🎁 Valor Recebido</p><p class="text-caption grey--text">Valor de crédito que o cliente receberá (bônus incluído)</p></div>
                  <v-divider class="my-2"></v-divider>
                  <div class="mb-3"><p class="font-weight-bold text-caption mb-1">🔢 Posição</p><p class="text-caption grey--text">Ordem de exibição no totem (1, 2, 3... em crescente)</p></div>
                  <v-divider class="my-2"></v-divider>
                  <div><p class="font-weight-bold text-caption mb-1">✅ Habilitado</p><p class="text-caption grey--text">Marque para ativar o combo ou desmarque para desativar</p></div>
                </v-card-text>
              </v-card>
          </v-menu>
  </div>
  <div class="breadcrumb-container" style="font-size: 13px; color: #666; margin-top: 2px;">
    <span style="color:#333333; cursor:pointer;" @click="$router.push('/home')">Homepage</span>
    <span> › </span>
    <span style="color:#333333; cursor:pointer;" @click="voltar">Combos</span>
    <span> › </span>
    <span>Novo Combo</span>
  </div>
</div>

          <div class="button-group-desktop d-none d-sm-flex" style="gap: 8px;">
  <v-btn elevation="0" color="primary" outlined @click="voltar" :disabled="loading">
    Voltar
  </v-btn>
  <v-btn elevation="0" color="primary" dark @click="abrirConfirmacao" :loading="loading">
    Salvar
  </v-btn>
</div>
        </div>
      </v-col>
    </v-row>

<!-- HEADER MOBILE -->
<v-row class="d-flex d-sm-none mb-4">
  <v-col cols="12">
 <div class="d-flex align-center">
    <span class="page-title">{{ page.title }}</span>
    <v-btn icon small color="primary" class="ml-2" @click="dialogAjudaMobile = true">
        <v-icon>mdi-help-circle-outline</v-icon>
    </v-btn>
</div>
    <div class="breadcrumb-container" style="font-size: 13px; color: #666; margin-top: 2px;">
      <span style="color:#333333; cursor:pointer;" @click="$router.push('/home')">Homepage</span>
      <span> › </span>
      <span style="color:#333333; cursor:pointer;" @click="voltar">Combos</span>
      <span> › </span>
      <span>Novo Combo</span>
    </div>
  </v-col>
</v-row>

<!-- BOTÕES MOBILE — próximos ao card Detalhes -->
<v-row class="d-flex d-sm-none mb-4">
  <v-col cols="6">
    <v-btn elevation="0" color="primary" outlined block @click="voltar" :disabled="loading">Voltar</v-btn>
  </v-col>
  <v-col cols="6">
    <v-btn elevation="0" color="primary" dark block @click="abrirConfirmacao" :loading="loading">Salvar</v-btn>
  </v-col>
</v-row>

    <v-form ref="form" v-model="valid" :disabled="loading" class="mt-6">
      <v-row>
        <v-col cols="12" class="px-0 px-sm-3">
          <v-card class="card-form-outlined pa-4 pa-sm-6">
       <v-card-title class="card-group-title px-0 pt-0 pb-4 d-flex align-center" style="gap: 12px;">
  <span>Detalhes do Combo</span>
  <span class="text-caption grey--text font-weight-regular">{{ combo.nome.length }}/30</span>
</v-card-title>

<v-card-text class="px-0 pb-0">
  <v-row>
    <v-col cols="12" sm="6" class="py-2 py-sm-3">
      <v-text-field
        dense
        label="Nome do Combo"
        v-model="combo.nome"
        outlined
        maxlength="30"
        :rules="[rules.required]"
        hide-details="auto"
      />
    </v-col>

                <v-col cols="12" sm="3" class="py-2 py-sm-3">
                  <v-text-field
                    dense
                    label="Valor Pago (R$)"
                    v-model="combo.valorPago"
                    outlined
                    placeholder="0,00"
                    reverse
                    :rules="[rules.required, rules.valor]"
                    hide-details="auto"
                    @input="formatarValor('valorPago', $event)"
                  />
                </v-col>

                <v-col cols="12" sm="3" class="py-2 py-sm-3">
                  <v-text-field
                    dense
                    label="Valor Recebido (R$)"
                    v-model="combo.valorRecebido"
                    outlined
                    placeholder="0,00"
                    reverse
                    :rules="[rules.required, rules.valor]"
                    hide-details="auto"
                    @input="formatarValor('valorRecebido', $event)"
                  />
                </v-col>

                <v-col cols="12" sm="3" class="py-2 py-sm-3">
  <v-text-field
    dense
    label="Posição"
    v-model="combo.posicao"
    outlined
    type="number"
    :rules="[rules.required, rules.posicao]"
    hide-details="auto"
  />
</v-col>

<v-col cols="12" sm="3" class="py-2 py-sm-3 d-flex align-center" style="height: 56px;">
  <v-switch
    v-model="combo.habilitado"
    :label="combo.habilitado ? 'Habilitado' : 'Desabilitado'"
    color="success"
    hide-details
    inset
    class="ma-0"
  />
</v-col>

              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-form>

    <!-- DIALOG CONFIRMAR -->
    <v-dialog v-model="dialogConfirmar" max-width="400">
      <v-card>
        <v-card-title class="headline">Novo Combo</v-card-title>
        <v-card-text>Deseja criar este combo?</v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text color="error" @click="dialogConfirmar = false">Cancelar</v-btn>
          <v-btn color="primary" @click="salvar">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
<v-dialog v-model="dialogAjudaMobile" scrollable content-class="popup-mobile-dialog">
    <v-card>
        <div class="popup-mobile-header">
            <span class="popup-mobile-header-title">
                <v-icon small class="mr-2">mdi-lightbulb-on</v-icon>Ajuda dos Campos
            </span>
            <v-btn icon small class="popup-mobile-close" @click="dialogAjudaMobile = false">
                <v-icon size="18">mdi-close</v-icon>
            </v-btn>
        </div>
        <v-divider></v-divider>
        <v-card-text class="pt-3 pb-3">
            <div class="mb-3"><p class="font-weight-bold text-caption mb-1">📝 Nome do Combo</p><p class="text-caption grey--text">Identificador único do combo (ex: Combo Premium)</p></div>
            <v-divider class="my-2"></v-divider>
            <div class="mb-3"><p class="font-weight-bold text-caption mb-1">💵 Valor Pago</p><p class="text-caption grey--text">Valor que o cliente paga para obter o crédito</p></div>
            <v-divider class="my-2"></v-divider>
            <div class="mb-3"><p class="font-weight-bold text-caption mb-1">🎁 Valor Recebido</p><p class="text-caption grey--text">Valor de crédito que o cliente receberá (bônus incluído)</p></div>
            <v-divider class="my-2"></v-divider>
            <div class="mb-3"><p class="font-weight-bold text-caption mb-1">🔢 Posição</p><p class="text-caption grey--text">Ordem de exibição no totem (1, 2, 3... em crescente)</p></div>
            <v-divider class="my-2"></v-divider>
            <div><p class="font-weight-bold text-caption mb-1">✅ Habilitado</p><p class="text-caption grey--text">Marque para ativar o combo ou desmarque para desativar</p></div>
        </v-card-text>
    </v-card>
</v-dialog>
  </v-container>
</template>

<script>
import axios from "@/plugins/axios";

export default {
  name: "ComboForm",

  data() {
    return {
      valid: false,
      loading: false,
      dialogConfirmar: false,
      dialogAjudaMobile: false,

      page: { title: "Novo Combo" },

     combo: {
    nome: "",
    valorPago: "",
    valorRecebido: "",
    habilitado: true,
    posicao: ""  // ← NOVO
},
      rules: {
    required: v => !!v || "Campo obrigatório",
    valor: v => {
      if (!v) return "Campo obrigatório";
      const n = parseFloat(String(v).replace(",", "."));
      return (!isNaN(n) && n > 0) || "Informe um valor válido";
    },
    posicao: v => {  // ← NOVO
      if (!v) return "Posição é obrigatória";
      const n = parseInt(v);
      return (!isNaN(n) && n > 0) || "Posição deve ser um número maior que zero";
    }
}
    };
  },

  methods: {
    formatarValor(campo, v) {
      if (!v) { this.combo[campo] = ""; return; }
      const limpo = v.replace(/\D/g, "");
      if (!limpo) { this.combo[campo] = ""; return; }
      this.combo[campo] = (parseInt(limpo) / 100).toFixed(2).replace(".", ",");
    },

    abrirConfirmacao() {
      if (!this.$refs.form.validate()) return;
      this.dialogConfirmar = true;
    },

    async salvar() {
  this.dialogConfirmar = false;
  this.loading = true;
  try {
    const operacaoId = localStorage.getItem('operation');
    await axios.post("/api/combos", {
      nome: this.combo.nome,
      valorPago: parseFloat(String(this.combo.valorPago).replace(",", ".")),
      valorRecebido: parseFloat(String(this.combo.valorRecebido).replace(",", ".")),
      habilitado: this.combo.habilitado,
      posicao: parseInt(this.combo.posicao), 
      operacaoId: operacaoId
        });

        this.$dialog.notify.info("Combo criado com sucesso!", { position: "top-right", timeout: 3000 });
        this.voltar();
      } catch (err) {
        let msg = "Erro ao criar combo.";
        if (err && err.response && err.response.data && err.response.data.mensagem) msg = err.response.data.mensagem;
        this.$dialog.notify.error(msg, { position: "top-right", timeout: 5000 });
      } finally {
        this.loading = false;
      }
    },

    voltar() {
      this.$router.push("/combos");
    }
  }
};
</script>

<style scoped>
.v-card { border-radius: 12px; }
.title-container { gap: 16px; width: 100%; }
.page-title { font-size: 24px; font-weight: 700; }
.button-group-desktop .v-btn { min-width: 130px; }

.v-btn { font-weight: 600; text-transform: none; }
.card-group-title { font-size: 16px !important; font-weight: 600; }
.ga-3 { gap: 24px; }

.popup-mobile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 12px 16px;
}

.popup-mobile-header-title {
  font-size: 17px;
  font-weight: 700;
  color: #333;
  display: flex;
  align-items: center;
}

.popup-mobile-close.v-btn {
  background-color: #f0f0f0 !important;
  border-radius: 50% !important;
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  box-shadow: none !important;
}

.popup-mobile-close.v-btn .v-icon {
  color: #555 !important;
}

.popup-mobile-dialog {
  border-radius: 12px;
}
</style>